import jwtDecode from 'jwt-decode';
import axios, { AxiosRequestConfig } from 'axios';
import config from '../../config';
import { deleteAuthUser, getAuthUser, saveAuthUser } from 'caches/user';
import Endpoints from '../endpoints';
import { Session } from 'data/types';

type ApiRequestConfig = AxiosRequestConfig;

// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.baseURL = config.API_URL;

// intercepting to capture errors
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // let message;

        if (error && error.response) {
            return error.response;
        }
        // else if (error && error.response && error.response.status === 403) {
        //     // window.location.href = '/access-denied';
        //     alert('acesso negado');
        // } else {
        //     switch (error.response.status) {
        //         case 401:
        //             message = 'Invalid credentials';
        //             break;
        //         case 403:
        //             message = 'Access Forbidden';
        //             break;
        //         case 404:
        //             message = 'Sorry! the data you are looking for could not be found';
        //             break;
        //         default: {
        //             message =
        //                 error.response && error.response.data ? error.response.data['message'] : error.message || error;
        //         }
        //     }
        //     return Promise.reject(message);
        // }
        return Promise.reject('server_error');
    }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
    if (token) axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    else delete axios.defaults.headers.common['Authorization'];
};

class APICore {
    endpoints = Endpoints;
    /**
     * Fetches data from given url
     */
    get = (url: string, params?: any) => {
        // let queryString;
        // if (params) {
        //     queryString = params
        //         ? Object.keys(params)
        //               .map((key) => key + '=' + params[key])
        //               .join('&')
        //         : '';
        //     if (queryString) url += `?${queryString}`;
        // }
        return axios.get(`${url}`, { params });
    };

    getFile = (url: string, params?: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                      .map((key) => key + '=' + params[key])
                      .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * post given data to url
     */
    create = (url: string, data: any, config: ApiRequestConfig = {}) => {
        return axios.post(url, data, config);
    };

    /**
     * Updates patch data
     */
    updatePatch = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.put(url, data);
    };

    /**
     * Deletes data
     */
    delete = (url: string) => {
        return axios.delete(url);
    };

    /**
     * post given data to url with file
     */
    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config: any = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();

        if (!user || (user && !user.token) || !user?.token) {
            return false;
        }

        const decoded: any = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            console.warn('access token expired');
            deleteAuthUser();
            return false;
        } else {
            return true;
        }
    };

    setLoggedInUser = (session: Session | null) => {
        if (session) saveAuthUser(session);
        else {
            deleteAuthUser();
        }
    };
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        return getAuthUser();
    };

    setUserInSession = (modifiedUser: any) => {
        let userInfo = this.getLoggedInUser();
        if (userInfo) {
            const { token, ...user } = userInfo;
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
    };

    refreshAuthorization = (token = null) => {
        if (token) {
            setAuthorization(token);
        } else {
            let user = getAuthUser();
            if (user) {
                const { token } = user;
                if (token) {
                    setAuthorization(token);
                }
            }
        }
    };

    refreshToken = () => {
        let user = getAuthUser();
        if (user) {
            const { refresh } = user;
            if (refresh) {
                console.log('REFRESH TOKEN HERE');
            }
        }
    };
}

/*
Check if token available in session
*/
let user = getAuthUser();
if (user) {
    const { token } = user;
    if (token) {
        setAuthorization(token);
    }
}

export { APICore, setAuthorization };
